import { render, staticRenderFns } from "./questionInfo.vue?vue&type=template&id=26cad674&scoped=true"
import script from "./questionInfo.vue?vue&type=script&lang=js"
export * from "./questionInfo.vue?vue&type=script&lang=js"
import style0 from "./questionInfo.vue?vue&type=style&index=0&id=26cad674&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26cad674",
  null
  
)

export default component.exports